// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"52":"3c735f09","311":"658b9613","355":"5c0c5716","453":"a3256751","455":"b8c8cce4","565":"15cfea5b","580":"2a6b1b7d","626":"e9840845","654":"f9f845fc","675":"6e967ded","689":"bf9de0b0","977":"0b618b39"}[chunkId] + ".chunk.js";
};